import { defaultAd300x250, IAdUnit } from "../unit";

export enum DesktopHomepageScrollEnum {
  DesktopHomepageScroll1 = "Desktop Homepage Scroll 1",
  DesktopHomepageScroll2 = "Desktop Homepage Scroll 2",
  DesktopHomepageScroll3 = "Desktop Homepage Scroll 3",
  DesktopHomepageScroll4 = "Desktop Homepage Scroll 4",
  DesktopHomepageScroll5 = "Desktop Homepage Scroll 5",
  DesktopHomepageScroll6 = "Desktop Homepage Scroll 6",
  DesktopHomepageScroll7 = "Desktop Homepage Scroll 7",
  DesktopHomepageScroll8 = "Desktop Homepage Scroll 8",
  DesktopHomepageScroll9 = "Desktop Homepage Scroll 9",
  DesktopHomepageScroll10 = "Desktop Homepage Scroll 10",
}

export const DesktopHomepageScrollUnits: { [name in DesktopHomepageScrollEnum]: IAdUnit } = {
  [DesktopHomepageScrollEnum.DesktopHomepageScroll1]: {
    ...defaultAd300x250,
    sid: "1232689",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll2]: {
    ...defaultAd300x250,
    sid: "1232690",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll3]: {
    ...defaultAd300x250,
    sid: "1232691",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll4]: {
    ...defaultAd300x250,
    sid: "1232692",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll5]: {
    ...defaultAd300x250,
    sid: "1232693",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll6]: {
    ...defaultAd300x250,
    sid: "1232694",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll7]: {
    ...defaultAd300x250,
    sid: "1232695",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll8]: {
    ...defaultAd300x250,
    sid: "1232696",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll9]: {
    ...defaultAd300x250,
    sid: "1232697",
  },
  [DesktopHomepageScrollEnum.DesktopHomepageScroll10]: {
    ...defaultAd300x250,
    sid: "1232698",
  },
};
